module.exports = __webpack_public_path__ + "Roboto-BlackItalic.ad0f284c7113fd0aaf39.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.ttf
// module id = 102
// module chunks = 17